<template>
  
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16.748"
    height="16.723"
    viewBox="0 0 16.748 16.723"
  >
    <path
      id="Path_17045"
      data-name="Path 17045"
      d="M16.468,4.685A8.333,8.333,0,0,0,2.9,13.852a.883.883,0,0,1,.075.533L2.243,17.91a.828.828,0,0,0,.833,1h.167l3.567-.717a1.05,1.05,0,0,1,.533.075A8.333,8.333,0,0,0,16.509,4.7ZM7.243,11.41a.833.833,0,1,1,.833-.833A.833.833,0,0,1,7.243,11.41Zm3.333,0a.833.833,0,1,1,.833-.833A.833.833,0,0,1,10.576,11.41Zm3.333,0a.833.833,0,1,1,.833-.833A.833.833,0,0,1,13.909,11.41Z"
      transform="translate(-2.222 -2.225)"
      fill="#fff"
    />
  </svg>
</template>
